// extracted by mini-css-extract-plugin
module.exports = {"grid":"CreateProfileStep5_grid__3HUXZ","block":"CreateProfileStep5_block__1zXi-","title":"CreateProfileStep5_title__1ZyMk","subtitle":"CreateProfileStep5_subtitle__11Ati"};